import React, { useEffect, useState } from 'react'
import './Admin.css';
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import axios from 'axios';
import apiUrl from '../../Environment/Api';
import { FaTrash } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function Category() {

    useEffect(() => {
        getdata();
    }, [])
    const toaster = () => {
        toast.success('Data submitted successfully!', {
          autoClose: 3000,
          hideProgressBar: true,
          className:'toaster',
        });
      };
      
      const toasterupdate = () => {
        toast.success('Data Updated successfully!', {
          autoClose: 3000,
          hideProgressBar: true,
          className: 'toast-warning1', // Apply a warning class
        });
      };
      
      const toasterdelete = () => {
        toast.success('Data Deleted successfully!', {
          autoClose: 3000,
          hideProgressBar: true,
          className: 'toast-error', // Apply an error class
        });
      };
      

    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        "type": '',
        "price": '',
        "INRprice":''
    });

    const handleNewButtonClick = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    // post 
    const handlesubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(apiUrl + '/category', formData);
            console.log("posted", response);
            setFormData({
                "type": '',
                "price": '',
                "INRprice": ''

            });
            getdata();
            handleCloseModal();
            toaster();
        } catch (err) {
            console.log("error", err);
        }
    }

    //update
    const [showModal1, setShowModal1] = useState(false);
    const handleCloseModal1 = () => {
        setShowModal1(false);
    };
    const [formData1, setFormData1] = useState({
        "type": '',
        "price": '',
        "INRprice":''
    });

    const handleupdatesubmit = async (e) => {
        e.preventDefault();
        try {

            const response = await axios.put(apiUrl + `/category/${categoryid}`, formData1);
            console.log("posted", response);

            setFormData({
                "type": '',
                "price": '',
                "INRprice": ''
            });
            handleCloseModal1();
            getdata();
            toasterupdate();

        } catch (err) {
            console.log("error", err);
        }
    }
    //get
    const [getData, setData] = useState([])
    const getdata = async () => {
        try {
            const response = await axios.get(apiUrl + '/category');
            setData(response.data);
            console.log("----------get data",response.data)
            setFilteredData(response.data);
        }
        catch (error) {
            console.log(error)
        }
    }
    const [filteredData, setFilteredData] = useState([]);
    const handlesearchFilter = (e) => {
        e.preventDefault();
        const inputValue = e.target.value.trim().toLowerCase();
        const filteredData = getData.filter((data) =>
            Object.values(data).some(
                (value) =>
                    value.toString().toLowerCase().includes(inputValue)
            )
        );
        setFilteredData(filteredData);
        setCurrentPage(1);
    };

    const [categoryid, setcategoryid] = useState('');
    function handleEdit(id) {
        const categorytoUpdate = getData.find((item) => item.id === id);
        setcategoryid(categorytoUpdate.id);

        setFormData1({
            type: categorytoUpdate.type,
            price: categorytoUpdate.price,
            INRprice:categorytoUpdate.INRprice
        })
        setShowModal1(true);
    }

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDeleteModaltype, setShowDeleteModaltype] = useState('');

    const [getDeleteId, setDeleteId] = useState(false);
    const handledeletepopup = (id, type) => {
        setShowDeleteModaltype(type)
        setShowDeleteModal(true);

        setDeleteId(id);
    }
    const handledeleteclose = () => {
        setShowDeleteModal(false);
    }

    //delete
    const handledelete = async () => {

        try {
            const response = await axios.delete(apiUrl + `/category/${getDeleteId}`);
            console.log(response);
            getdata();
            toasterdelete();
        }
        catch (error) {
            console.log(error)
        }
        setShowDeleteModal(false);
    }

    //pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice().reverse().slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleItemsPerPageChange = (e) => {
        setCurrentPage(1);
        setItemsPerPage(Number(e.target.value));
    };


    return (
        <div>
            <ToastContainer />
            <div className="d-flex">
                <h5 className="mt-2">Type Details</h5>
                <button className="btn  btn-success mx-3 addbutton-heading" onClick={handleNewButtonClick}>
                    ADD
                </button>
            </div>
            <div>
                <Modal className="modal" show={showModal} onHide={handleCloseModal}>
                    <form onSubmit={handlesubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Type</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <label className="form-label">
                                <b>Type :</b>
                            </label>
                            <input className="form-control" type="text" name='type' value={formData.type} onChange={(e) => setFormData({ ...formData, type: e.target.value })} placeholder="Enter Type" required />
                            <label className="form-label pt-2">
                                <b>$ Dollar Rate :</b>
                            </label>
                            <input className="form-control" type="number" name='price' value={formData.price} onChange={(e) => setFormData({ ...formData, price: e.target.value.replace('$', '') })} placeholder="Enter $ Price"  />
                            <label className="form-label pt-2">
                                <b>₹ INR Rate :</b>
                            </label>
                            <input className="form-control" type="number" name='price' value={formData.INRprice} onChange={(e) => setFormData({ ...formData, INRprice: e.target.value.replace('$', '') })} placeholder="Enter INR Price" />
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Close
                            </Button>
                            <Button variant="primary" type='submit'>Submit</Button>
                        </Modal.Footer>
                    </form>
                </Modal>
            </div>
            {/* //update */}
            <Modal className="modal" show={showModal1} onHide={handleCloseModal1}>
                <form onSubmit={handleupdatesubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Type</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="form-label">
                            <b>Type :</b>
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            name='type'
                            value={formData1.type}
                            onChange={(e) => setFormData1({ ...formData1, type: e.target.value })}
                            placeholder="Enter Type" required
                        />
                        <label className="form-label pt-2">
                            <b>$ Dollar Rate :</b>
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            name='price'
                            value={formData1.price}
                            onChange={(e) => setFormData1({ ...formData1, price: e.target.value.replace('$', '') })}
                            placeholder="Enter Price" 
                        />
                        <label className="form-label pt-2">
                            <b>₹ INR Price :</b>
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            name='INRprice'
                            value={formData1.INRprice}
                            onChange={(e) => setFormData1({ ...formData1, INRprice: e.target.value.replace('$', '') })}
                            placeholder="Enter INR Price" 
                        />

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal1}>
                            Close
                        </Button>
                        <Button variant="primary" type='submit'>Update</Button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* Delete */}
            <Modal show={showDeleteModal} onHide={handledeleteclose} >
                <Modal.Header>
                    <Modal.Title> <div className='row'>
                        <div className='col-lg-2 d-flex justify-content-center pt-2'><img className='trash' src={require('../../../assets/img/Admin/bin.png')} /></div>
                        <div className='col-lg-10'>  <p className='popup-delete-text'>Are you sure you want to delete ?</p>
                            <h6>Type: <b> {showDeleteModaltype}</b></h6> </div>
                    </div> </Modal.Title>
                </Modal.Header>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handledeleteclose}>
                        Close
                    </Button>
                    <Button variant="danger" type='submit' onClick={handledelete}>Delete</Button>
                </Modal.Footer>
            </Modal>


            <hr />
            <div class="row">
                <div class="col-md-12">
                    {/* <!-- DATA TABLE --> */}

                    <div className='d-flex justify-content-between'>
                        <div className=''>
                            <label>Show per page:</label>
                            <select className='form-control' value={itemsPerPage} onChange={handleItemsPerPageChange}>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>
                        </div>
                        <form>
                            <label>Search :</label>
                            <input className='form-control' type='text' onChange={handlesearchFilter}></input>
                        </form>
                    </div>
                    <div class="table-responsive table-responsive-data2 mt-2">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>S.No</th>

                                    <th>Type</th>
                                    <th>$ Dollar Rate</th>
                                    <th>₹ INR Rate</th>
                                    <th className='text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                                        <td className="desc">{item.type}</td>
                                        <td className="desc">$ {item.price}</td>
                                        <td className='desc'>₹ {item.INRprice}</td>
                                        

                                        <td className='text-center'>
                                            <button className="btn btn-button mx-3 px-2 editbutton" onClick={() => handleEdit(item.id)}>
                                                <i class="fa-solid fa-pen-to-square"></i>
                                            </button>
                                            <button className="btn btn-button mx-3  px-2 deletebutton" onClick={() => handledeletepopup(item.id, item.type)}>
                                                <i class="fa-solid fa-trash"></i>

                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div>
                            <nav className='d-flex justify-content-end mx-2 pt-4'>
                                <ul className="pagination">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link mx-3" onClick={() => paginate(currentPage - 1)}>
                                            Previous
                                        </button>
                                    </li>
                                    {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
                                        <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                            <button className="page-link" onClick={() => paginate(index + 1)}>
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === Math.ceil(filteredData.length / itemsPerPage) ? 'disabled' : ''}`}>
                                        <button className="page-link mx-3" onClick={() => paginate(currentPage + 1)}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>


                    {/* <!-- END DATA TABLE --> */}
                </div>
            </div>

        </div>
    )
}

export default Category;